import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoBoardViewsAlternateTabs]',
  host: { class: 'xpo-BoardViewsAlternateTabs' },
})
export class XpoBoardViewsAlternateTabs {}
